module.exports = __webpack_public_path__ + "static/start-sp-6ad08b6c50e1b7ff02d09b1a131465c2.png";